import { Feedback } from './../models/Feedback';
import { TranslateService } from '@ngx-translate/core';
import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { throwError as observableThrowError } from 'rxjs/internal/observable/throwError';
import { environment } from '../../environments/environment';
import { UtilsService } from './utils.service';

@Injectable({
  providedIn: 'root'
})
export class FeedbackService {
  private apiBaseUrl = environment.apiBaseUrl;

  private static handleError(error: Response | any): Observable<any> {
    console.error('ApiService::handleError', error);
    return observableThrowError(error.error);
  }

  constructor(
    private http: HttpClient,
    private translateService: TranslateService,
    private utilsService: UtilsService
  ) {}

  getAllFeedback(): Observable<Array<Feedback>> {
    const url = `${this.apiBaseUrl}/feedback`;
    return this.http
      .get<Array<any>>(url)
      .pipe(catchError(FeedbackService.handleError));
  }

  getFeedbackById(id: string): Observable<Feedback> {
    const url = `${this.apiBaseUrl}/feedback/${id}`;
    return this.http
      .get<Feedback>(url)
      .pipe(catchError(FeedbackService.handleError));
  }

  saveFeedback(feedback: Feedback): Observable<Feedback> {
    const url = `${this.apiBaseUrl}/feedback`;
    return this.http
      .post<Feedback>(url, feedback)
      .pipe(catchError(FeedbackService.handleError));
  }

  updateFeedback(feedback: Feedback): Observable<Feedback> {
    const url = `${this.apiBaseUrl}/feedback`;
    return this.http
      .put<Feedback>(url, feedback)
      .pipe(catchError(FeedbackService.handleError));
  }

  deleteFeedback(id: string): Observable<void> {
    const url = `${this.apiBaseUrl}/feedback/${id}`;
    return this.http
      .delete<void>(url)
      .pipe(catchError(FeedbackService.handleError));
  }
}
